import { Routes } from '@angular/router';
import { LayoutComponent } from '../layout/layout.component';
import { LayoutHComponent } from '../layout/layouth.component';
import { AuthGuard } from '../shared/util/auth.guard';
import { Home } from './menu';

export const routes: Routes = [
  {
    path: '',
    //component: LayoutComponent,
    children: [
     // { path: '', redirectTo: 'thong-tin', pathMatch: 'full' },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      //{ path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule), component: LayoutComponent, canActivate: [AuthGuard], data: { auth: '1', func: Home.id } },
      { path: 'thong-tin', loadChildren: () => import('./thongtin/thongtin.module').then(m => m.ThongtinModule) },
      { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
      { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule), component: LayoutComponent, canActivate: [AuthGuard]},
      
      //{ path: 'login', loadChildren: './login/login.module#LoginModule' },
      { path: 'waitlogin', loadChildren: './waitlogin/waitlogin.module#WaitLoginModule' },
      { path: 'daotaos', loadChildren: () => import('./daotao/daotao.module').then(m => m.DaoTaoModule), component: LayoutComponent, canActivate: [AuthGuard] },
      { path: 'sathachs', loadChildren: () => import('./sathach/sathach.module').then(m => m.SatHachModule), component: LayoutComponent, canActivate: [AuthGuard] },
      //{ path: 'nhaplieu', loadChildren: () => import('./nhaplieu/nhaplieu.module').then(m => m.NhapLieuModule), component: LayoutComponent, canActivate: [AuthGuard] },
      //{ path: 'dautu', loadChildren: () => import('./dautu/dautu.module').then(m => m.DauTuModule), component: LayoutComponent, canActivate: [AuthGuard] },
      //{ path: 'hosocongchuc', loadChildren: () => import('./hosocongchuc/hosocongchuc.module').then(m => m.HoSoCongChucModule), component: LayoutComponent, canActivate: [AuthGuard] },
      { path: 'danhmuc', loadChildren: () => import('./danhmuc/danhmuc.module').then(m => m.DanhMucModule), component: LayoutComponent, canActivate: [AuthGuard] },
      { path: 'quantri', loadChildren: () => import('./quantri/quantri.module').then(m => m.QuanTriModule), component: LayoutComponent, canActivate: [AuthGuard] },
      { path: 'baocao', loadChildren: () => import('./baocao/baocao.module').then(m => m.BaoCaoModule), component: LayoutComponent, canActivate: [AuthGuard] },
      

      { path: 'dieuhanh', loadChildren: () => import('./dieuhanh/dieuhanh.module').then(m => m.DieuHanhModule), component: LayoutHComponent, canActivate: [AuthGuard] },
      { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashBoardModule), component: LayoutHComponent, canActivate: [AuthGuard] },

    ]
  },
  // Not found
  { path: '**', redirectTo: 'home' }
  // { path: '**', redirectTo: 'thong-tin' }

];
